// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__fWV9l"};
module.exports.__checksum = "4d674f11d843"
